import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyWelcomeVideo = loadable(() => import(/* webpackChunkName: "content/guest/widgets/welcomeVideo" */ './WelcomeVideo'), 'WelcomeVideo');
